import React from 'react';
import { Link } from 'react-router-dom';

import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';

import { copyArray, getDataFromState } from '../common/Utilities';
import DomainListService from '../services/DomainListService';
import SurveyService from '../services/SurveyService';
import Survey from '../models/SurveyModel';
import { correlatorUser } from '../common/Utilities';

import '../App.css';


class EditSurvey extends React.Component {

    constructor(props) {
        super(props);

        const localState = {
            // Collections for the domain lists for the drop down boxes
            areas: [],
            customers: [],
            technicians: [],
            surveytypes: [],
            surveystates: [],
            areaTechnicians: [],

            // Loading an existing survey for edit
            openDialogHidden: true,
            clientDialogHidden: true,
            askOpenSurvey: true,
            cancelDialogHidden: true,

            // Choice for saving clients that aren't in domain list. Default "persist" is save the client name to the data store
            saveClientOption: "persist",
            tempCustomers: [], // placeholder for original customers when a user adds a new client name

            // Combo box error messages
            areaErrorMessage: "",
            clientErrorMessage: "",
            // Filled by verifySurveyNotExists 
            surveyExistsMessage: "",

            // This indicates if a database write is necessary
            hasChanges: false,
            // 0 is no move, 1 is next, -1 is previous
            moveTo: 0,

            untouchedSurveyRecord: { ...props.data.survey }
        }

        const styles = {
            label: {
                fontSize: '12px',
            },
        };
        this.state = { ...props.data, ...localState };
    }

    existingSurvey = null;

    componentDidMount() {

        const db = new DomainListService();
        if (!(this.state.technicians && this.state.technicians.length > 0)) {
            db.getDomainList(db.LIST_TYPE.TECHNICIANS, (data) => {             
                this.setState({ technicians: data });               
            });
        }
        if (!(this.state.surveytypes && this.state.surveytypes.length > 0)) {
            db.getDomainList(db.LIST_TYPE.SURVEY_TYPES, (data) => {
                data.unshift({ text: "", key: "" });
                this.setState({ surveytypes: data });           
            });
        }
        if (!(this.state.surveystates && this.state.surveystates.length > 0)) {
            db.getDomainList(db.LIST_TYPE.SURVEY_STATES, (data) => {
                data.unshift({ text: "", key: "" });
                this.setState({ surveystates: data });            
            });
        }
        if (!(this.state.customers && this.state.customers.length > 0)) {
            db.getDomainList(db.LIST_TYPE.CUSTOMERS, (data) => {
                this.setState({ customers: data });            
            });
        }
        if (!(this.state.areas && this.state.areas.length > 0)) {
            var user = correlatorUser();
            //console.log(user);
            db.getDomainList(db.LIST_TYPE.AREAS, (data) => {
                if (user.roles.indexOf("SystemAdministrators") > -1) {
                    this.setState({ areas: data });
                }
                else {
                    //console.log(data);
                    var a = [];
                    data.forEach(function (val, idx) {
                        if (user.areas.indexOf(val.key) > -1) {
                            a.push(val);
                        }
                    });
                    this.setState({ areas: a });
                }
                console.log(this.state);
            });
        }
    }

    // componentDidUpdate(prevProps) {
    //     // Typical usage (don't forget to compare props):
    //     if (this.state.userID !== this.prevProps.userID) {
    //       this.fetchData(this.props.userID);
    //     }
    //   }

    onUndo = (e) => {
        this.setState({ survey: { ...this.state.untouchedSurveyRecord }, hasChanges: false, cancelDialogHidden: true });
        this.props.onSurveyChange(false);
    }

    setStateForProperty(propertyName, value, callback) {
        let survey = { ...this.state.survey }
        survey[propertyName] = value;
        this.setState({ survey: survey, hasChanges: true }, callback);
        this.props.onSurveyChange(true);
    };

    onAreaChanged = (e, option, index, value) => {
        if (option !== undefined) {
            this.setStateForProperty("surveyArea", option.key);
            this.setState({ areaErrorMessage: "" });
        } else {
            this.setStateForProperty("client", "");
        }
    };

    onClientChanged = (e, option, index, value) => {
        if (option !== undefined) {
            this.setStateForProperty("client", option.key);
            this.setState({ clientErrorMessage: "" });
        } else if (value !== undefined) {
            // User typed a freeform option
            if (value.trim().length > 0) {
                // Save the customers list in case the user cancels
                this.setState({ tempCustomers: [...this.state.customers] },
                    () => {
                        const newOption = { key: value.trim(), text: value.trim() };
                        this.setState({
                            customers: [...this.state.customers, newOption]
                        });
                        this.setStateForProperty("client", newOption.key,
                            this.setState({ clientDialogHidden: false })
                        );
                    }
                );
            }
        } else {
            this.setStateForProperty("client", "");
        }
    };

    onSurveyActivityChanged = (e, option) => {
        if (option !== undefined) {
            this.setStateForProperty("surveyActivity", option.key);
        } else {
            this.setStateForProperty("surveyActivity", "");
        }
    };
    onSurveyStateChanged = (e, option) => {
        if (option !== undefined) {
            this.setStateForProperty("surveyState", option.key);
        } else {
            this.setStateForProperty("surveyState", "");
        }
    };
    onTechnicianChanged = (e, item) => {
        const updatedSelectedItem = this.state.survey.technicians ? copyArray(this.state.survey.technicians) : [];
        if (item.selected) {
            // add the option if it's checked
            updatedSelectedItem.push(item.key);
        } else {
            // remove the option if it's unchecked
            const currIndex = updatedSelectedItem.indexOf(item.key);
            if (currIndex > -1) {
                updatedSelectedItem.splice(currIndex, 1);
            }
        }
        this.setStateForProperty("technicians", updatedSelectedItem);
    };

    saveRecordOnly = () => {
        this.onSubmit();
    };
    saveAndNext = () => {
        this.setState({ moveTo: 1 }, this.onSubmit);
    };

    onSubmit = async e => {
        if (e) e.preventDefault();
        let errorFree = true;

        const eMsg = await this.validateJobNumberFormat();
        if (eMsg.length > 0) {
            this.setState({ surveyExistsMessage: eMsg });
            errorFree = false;
        }

        if (this.state.survey.surveyArea === "") {
            errorFree = false;
            this.setState({ areaErrorMessage: "Office is Required" });
        }
        if (this.state.survey.client === "") {
            errorFree = false;
            this.setState({ clientErrorMessage: "Client is Required" });
        }
        if (errorFree && this.state.survey.schemaDTS === "") {
            const errorMessage = await this.verifySurveyNotExists();
            if (errorMessage.length > 0) {
                // When state gets set the getErrorMessage on the TextField for jobNumVendor will return
                // the state indicating an error on the field
                this.setState({ surveyExistsMessage: errorMessage });
                errorFree = false;
            }
        }
        if (errorFree) {
            //console.log(this.state.survey);
            if (this.state.hasChanges) {
                // Set the timestamp before saving. It's a new record - 
                // this tells when it was updated and not to validate if a user does a back and changes something
                const timeStamp = (new Date()).toISOString();
                this.setStateForProperty("schemaDTS", timeStamp, () => {
                    // Save the survey
                    const db = new SurveyService();
                    db.put(new Survey().fromSimple(this.state.survey).getDbObject());
                    //console.log(JSON.stringify(values, 0, 2))
                    this.props.onSave(getDataFromState(this.state), this.state.moveTo);
                    this.setState({hasChanges: false, moveTo: 0});
                    this.props.onSurveyChange(false);
                });
            } else {
                if (this.state.moveTo !== 0 ) {this.props.moveTo(this.state.moveTo); }
            }
        }
    };
    // onFormKeyPress = (e) => {
    //     if (e.target.type !== 'textarea' && e.target.type !== 'submit' && e.which === 13 /* Enter */) {
    //         e.preventDefault();
    //     }
    // };

    openSurveyDialog = () => { this.setState({ openDialogHidden: false }) };

    cancelOpenDialog = () => {
        this.setState({
            askOpenSurvey: false,
            openDialogHidden: true,
            hasChanges: false
        });
        this.props.onSurveyChange(false);
    };

    cancelClientDialog = () => {
        this.setStateForProperty("client", "");
        this.setState({
            customers: [...this.state.tempCustomers],   // restore the drop down list to the one prior to user addition
            clientDialogHidden: true
        });
    };

    applyClientNameOption = () => {
        if (this.state.saveClientOption === "persist") {
            const db = new DomainListService();
            db.putDomainList(db.LIST_TYPE.CUSTOMERS, this.state.survey.client);
        }
        this.setState({
            clientDialogHidden: true
        });
    };

    onOpenDialog = async () => {
        // put the existing survey into the state and reset messages
        this.setState({ survey: this.existingSurvey.getSimpleObject(), surveyExistsMessage: "", isNewSurvey: false },
            this.cancelOpenDialog);
    };

    getReadonly = name => (name === "jobNumVendor" && this.state.survey.schemaDTS.length > 0) ? "readonly" : "";

    validateJobNumberFormat = () => {
        const survey = this.state.survey;
        //console.log(survey);
        var rtnMsg = "";
        if (survey.schemaDTS === "") {           
            if (survey.jobNumVendor.length > 11) {
                rtnMsg = "Job numbers should begin with 'J' followed by 7 numeric characters. When multiple surveys under the same job number are needed, append -xx to the end of the job number where -xx represents -01, -02, etc.  Example job numbers can be J0000317, or J0000317-01.";
            }
            var regex = /[^-0-9]/g;
            if (regex.test(survey.jobNumVendor.slice(1)) === true) {
                rtnMsg = "Job numbers should begin with 'J' followed by 7 numeric characters. When multiple surveys under the same job number are needed, append -xx to the end of the job number where -xx represents -01, -02, etc.  Example job numbers can be J0000317, or J0000317-01.";
            }
            if (survey.jobNumVendor.startsWith("J") == false) {
                rtnMsg = "Job numbers should begin with 'J' followed by 7 numeric characters. When multiple surveys under the same job number are needed, append -xx to the end of the job number where -xx represents -01, -02, etc.  Example job numbers can be J0000317, or J0000317-01.";
            }
        }
        return rtnMsg;
    };

    verifySurveyNotExists = async () => {
        const survey = this.state.survey;
        const db = new SurveyService();        
        this.existingSurvey = await db.get(survey.jobNumVendor);
        console.log(this.existingSurvey);
        if (this.existingSurvey.dbObject.hasOwnProperty("NULL") === false) {
            // Open the dialog to ask if this survey should be opened if it exists already
            // and we haven't previously asked for this survey before
            if (this.state.openDialogHidden && this.state.askOpenSurvey) {
                this.openSurveyDialog();
            }
            return `A survey with Job Id:${survey.jobNumVendor} Client: ${survey.client} already exists.`;
        } else {
            return '';
        }
    };

    render() {

        // const checkboxStyles = () => {
        //     return {
        //       root: {
        //         width: '300px',
        //         marginTop: '14px'
        //       }
        //     };
        //   };

        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-10 col-md-8 col-lg-6">
                        <h2 className="heading" >{this.state.survey.schemaDTS === "" ? "New Survey" : "Survey"}</h2>
                        {this.state.surveyExistsMessage.length > 0 && <MessageBar messageBarType={MessageBarType.error}>
                            {this.state.surveyExistsMessage}
                        </MessageBar>
                        }
                        <form onSubmit={this.onSubmit} >
                            <TextField style={{ 'fontSize': '12px', 'color': '#676767' }} label="Job Number" required={true} value={this.state.survey.jobNumVendor}            
                                classes={{label:'labels'}}
                                disabled={this.state.survey.schemaDTS !== ""}
                                onChange={(e, value) => {
                                    this.setStateForProperty("jobNumVendor", value);
                                    this.setState({ surveyExistsMessage: "" });
                                }} />
                            <ComboBox
                                style={{ 'fontSize': '12px', 'color': '#676767' }}
                                selectedKey={this.state.survey.surveyArea && this.state.survey.surveyArea}
                                label="Office"
                                // disabled={this.state.survey.schemaDTS !== ""}
                                allowFreeform={false}
                                autoComplete="on"
                                options={this.state.areas}
                                required={true}
                                errorMessage={this.state.areaErrorMessage}
                                onChange={this.onAreaChanged}
                            />
                            <ComboBox
                                style={{ 'fontSize': '12px', 'color': '#676767'}}
                                selectedKey={this.state.survey.client && this.state.survey.client}
                                label="Client"
                                disabled={this.state.survey.schemaDTS !== ""}
                                allowFreeform={false}
                                autoComplete="on"
                                options={this.state.customers}
                                required={true}
                                errorMessage={this.state.clientErrorMessage}
                                onChange={this.onClientChanged}
                            />
                           
                          
                            <TextField style={{ 'fontSize': '12px', 'color': '#676767'}} label="Project Description" value={this.state.survey.projDesc} required={true}
                                multiline rows={3}
                                onChange={(e, value) => this.setStateForProperty("projDesc", value)} />
                                                       
                            <ComboBox
                                style={{ 'fontSize': '12px', 'color': '#676767' }}
                                selectedKey={this.state.survey.surveyActivity && this.state.survey.surveyActivity}
                                label="Survey Activity"
                                allowFreeform={false}
                                autoComplete="on"
                                options={this.state.surveytypes}
                                onChange={this.onSurveyActivityChanged} />
                            <ComboBox
                                style={{ 'fontSize': '12px', 'color': '#676767'}}
                                selectedKey={this.state.survey.surveyState && this.state.survey.surveyState}
                                label="Survey State"
                                allowFreeform={false}
                                autoComplete="on"
                                options={this.state.surveystates}
                                onChange={this.onSurveyStateChanged} />

                            {/* <Checkbox label="Survey is Complete" checked={this.state.survey.surveyState === "Complete"}
                    disabled={this.state.survey.surveyState === "ReadyToDownload"}
                    styles={checkboxStyles}
                    onChange={(e, isChecked) => 
                        this.setStateForProperty("surveyState", isChecked ? "Complete" : "Active")
                    } /> */}

                            <Dropdown
                                style={{ 'fontSize': '12px', 'color': '#676767'}}
                                placeHolder="Select options"
                                label="Technicians"
                                selectedKeys={this.state.survey.technicians}
                                onChange={this.onTechnicianChanged}
                                multiSelect
                                options={this.state.technicians} />

                            <div className="buttonRow" style={{ marginTop: "15px" }}>
                                <div >
                                    <button style={{ 'fontSize': '12px', 'color': '#676767'}} type="button" onClick={this.saveAndNext} className="btn btn-default">Next</button>
                                </div>
                                <div >
                                    <button style={{ 'fontSize': '12px', 'color': '#676767' }} type="button" onClick={this.saveRecordOnly}
                                        disabled={!this.state.hasChanges}
                                        className="btn btn-default">Save</button>
                                </div>
                                <div >
                                    <button style={{ 'fontSize': '12px', 'color': '#676767' }} type="button" onClick={() => { this.setState({ cancelDialogHidden: false }) }}
                                        disabled={!this.state.hasChanges}
                                        className="btn btn-default">Undo Changes</button>
                                </div>
                                <div >
                                    <Link to="/">
                                        <button style={{ 'fontSize': '12px', 'color': '#676767' }} className="btn btn-default">Home</button>
                                    </Link>
                                </div>
                            </div>

                        </form>
                        <Dialog
                            style={{ 'fontSize': '12px', 'color': '#676767'}}
                            hidden={this.state.cancelDialogHidden}
                            onDismiss={() => { this.setState({ cancelDialogHidden: true }) }}
                            dialogContentProps={{
                                type: DialogType.normal,
                                title: 'Cancel Changes',
                                subText:
                                    'Are you sure that you would like to undo your changes?'
                            }}
                            modalProps={{
                                isBlocking: true
                            }}
                        >
                            <DialogFooter>
                                <PrimaryButton  onClick={this.onUndo} text="Undo" />
                                <DefaultButton  onClick={() => { this.setState({ cancelDialogHidden: true }) }} text="Keep Changes" />
                            </DialogFooter>
                        </Dialog>
                        <Dialog
                            hidden={this.state.openDialogHidden}
                            onDismiss={this.cancelOpenDialog}
                            dialogContentProps={{
                                type: DialogType.normal,
                                title: 'Open Existing Survey',
                                subText:
                                    'A Survey with the specified Job Id and Client already exist. Would you like to open it?'
                            }}
                            modalProps={{
                                isBlocking: true
                            }}
                        >
                            <p>Job Id: {this.state.survey.jobNumVendor}</p>
                            <p>Client: {this.state.survey.client}</p>
                            <DialogFooter>
                                <PrimaryButton onClick={this.onOpenDialog} text="Open" />
                                <DefaultButton onClick={this.cancelOpenDialog} text="Cancel" />
                            </DialogFooter>
                        </Dialog>
                        <Dialog
                            hidden={this.state.clientDialogHidden}
                            onDismiss={this.cancelClientDialog}
                            dialogContentProps={{
                                type: DialogType.largeHeader,
                                title: 'New Client Name',
                                subText: `"${this.state.survey.client}" does not exist in the permanent list of Clients. How do you want to save the Client Name?`
                            }}
                            modalProps={{
                                isBlocking: true,
                                containerClassName: 'ms-dialogMainOverride'
                            }}
                        >
                            <ChoiceGroup
                                options={[
                                    {
                                        key: 'persist',
                                        text: 'Add to permanent list of clients',
                                        checked: this.state.saveClientOption === "persist"
                                    },
                                    {
                                        key: 'dontPersist',
                                        text: 'Do NOT save to list but use the Client Name for this survey',
                                        checked: this.state.saveClientOption === "dontPersist"
                                    }
                                ]}
                                onChange={(e, option) => {
                                    this.setState({ saveClientOption: option.key })
                                }}
                            />
                            <DialogFooter>
                                <PrimaryButton onClick={this.applyClientNameOption} text="Apply" />
                                <DefaultButton onClick={this.cancelClientDialog} text="Cancel" />
                            </DialogFooter>
                        </Dialog>
                    </div>
                    <div className="col-sm-1 col-md-2 col-lg-3"></div>
                </div>
            </div>
        );
    }
}

export default EditSurvey;
